import config from 'react-global-configuration';

export let APP_ENV = process.env.REACT_APP_ENV;
export const __DEBUG__ = APP_ENV !== 'production';
export const USE_SENTRY = process.env.REACT_APP_SENTRY_ENABLED;
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

export const DEFAULT_LANGUAGE = 'nl';
export const MULTILINGUAL = true;
export const SITE_NAME = 'verpact';
export const APP_ROOT_ELEMENT_ID = 'root';
export const PRIVACY_POLICY = 'https://www.verpact.nl/privacy-en-cookieverklaring';

export const IS_SERVER = !(
  typeof window !== 'undefined'
  && window.document
  && window.document.createElement
);
export const IS_CLIENT = !IS_SERVER;

let API_URL = process.env.REACT_APP_API_URL || '//verpact.devinc.eu';
// let API_URL = 'http://localhost:3000/api'; // <- For local proxy.


// If we provide the API URL in the DOM, use that instead.
if (IS_CLIENT && document.getElementById(APP_ROOT_ELEMENT_ID).dataset.apiUrl) {
  API_URL = document.getElementById(APP_ROOT_ELEMENT_ID).dataset.apiUrl;
}

export const LANGUAGES = {
  nl: 'Ga naar nederlands',
  en: 'Switch to English',
};

// const APOLLO_SEARCH_URL = process.env.REACT_APP_APOLLO_SEARCH_URL || "http://verpact.devinc.eu:4000/";
const APOLLO_SEARCH_URL = process.env.REACT_APP_APOLLO_SEARCH_URL || '/apollo/api/graphql';
const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';

// The value is where the breakpoint starts (mobile-first).
// These values are taken from '/src/src/styles/assets/_variables.scss'.
export const SCREEN_MOBILE = 0;
export const SCREEN_TABLET = 768;
export const SCREEN_NORMAL = 992;
export const SCREEN_WIDE = 1240;
export const SCREEN_HUGE = 2000;

// Block ID constants
export const BLOCK_NEWSLETTER_BLOCK_ID = 3;

// Taxonomy terms
export const TAXONOMY_TERM_HELP_TYPE_GENERAL = 18;
export const TAXONOMY_TERM_HELP_TYPE_ADMINISTRATION = 20;
export const TAXONOMY_TERM_HELP_TYPE_TARIFFS = 19;
export const TAXONOMY_TERM_HELP_TYPE_PPWR = 38;
export const TAXONOMY_TERM_ARTICLE_TYPE_PRESS = 5;

// Certain pages constants
export const PAGES_MORE_NEWS_URL = '/node/472';


export let APP_OPTIONS = {
  apiUrl: API_URL,
  element: '',
  parameters: {
    env: 'production',
  }
};

// Use config to share static configuration between components and packages.
config.set({
  'SITE_NAME': SITE_NAME,
  'MULTILINGUAL': MULTILINGUAL,
  'DEFAULT_LANGUAGE': DEFAULT_LANGUAGE,
  'LANGUAGES': LANGUAGES,
  'API_URL': API_URL,
  'APOLLO_SEARCH_URL': APOLLO_SEARCH_URL,
  'RECAPTCHA_SITE_KEY': RECAPTCHA_SITE_KEY,
  'PAGE_TRANSITION_SPEED': 200,
}, { freeze: false });

export function saveConstants(options) {
  APP_OPTIONS = options;

  if (options.parameters.env) {
    APP_ENV = options.parameters.env;
  }

  if (options.apiUrl) {
    API_URL = options.apiUrl;
  }

  if (APP_ENV === 'development') {
    // Use proxy in dev to prevent CORS issues.
    API_URL = 'http://localhost:3000/api';
  }

  // Update the config.
  config.set({
    'SITE_NAME': SITE_NAME,
    'MULTILINGUAL': true,
    'DEFAULT_LANGUAGE': DEFAULT_LANGUAGE,
    'LANGUAGES': LANGUAGES,
    'API_URL': API_URL,
    'APOLLO_SEARCH_URL': APOLLO_SEARCH_URL,
    'RECAPTCHA_SITE_KEY': RECAPTCHA_SITE_KEY,
    'PAGE_TRANSITION_SPEED': 200,
  });
}
